export enum DragType {
  GEOMETRY_ENTRY = "GEOMETRY_ENTRY",
  KVS_DOCUMENT_ENTRY = "KVS_DOCUMENT_ENTRY",
  MATERIAL_INFO_ENTRY = "MATERIAL_INFO_ENTRY",
  PARTLIST_ENTRY = "PARTLIST_ENTRY",
  TARGET = "TARGET",
  TMM_ENTRY = "TMM_ENTRY",
}
